export default "__VITE_ASSET__lPgyBkCz__ 682w, __VITE_ASSET__mk920jWb__ 600w, __VITE_ASSET__h4I_YZzh__ 400w";